import './bigFiveForm/BigFiveForm.css';
import React from 'react'
import AppForm from './bigFiveForm/components/AppForm.js'
import Popup from './bigFiveForm/components/Popup.js'
import NavBar from './reusable/NavBar';
import Footer from './reusable/Footer.js'
import useAppShell from '../../hooks/useAppShell.js'

function App() {

  const [showPopup, setShowPopup] = React.useState({
    show: false,
    type: "",
  });

  function handleTogglePopup(value) {
    setShowPopup(value);
  }

  // On phones the assessment is a fixed, app-like screen: the page itself never scrolls (IMP-087)
  useAppShell();

  return (
    <div className="App App--shell">
      <NavBar layout="form" /> {/* NavBar css is in App.css instead of BigFiveForm */}
      <div className="App--header-design">
      </div>
      <AppForm
        handleTogglePopup={handleTogglePopup}
      />
      <Footer layout="form" />{/* NavBar css is in App.css instead of BigFiveForm */}
      {showPopup.show && <Popup
        handleTogglePopup={handleTogglePopup}
        type={showPopup.type}
      />}
    </div>
  );
}

export default App;
